import { Conditionals } from "./conditionals.js";

class App {

    #conditionals;

    constructor() {
        document.addEventListener('DOMContentLoaded', () => {
            this.onDomReady();
        });

        document.addEventListener('alpine:init', () => {
            const obj = this;

            Alpine.data('copy', () => ({
                target: null,
                init() {
                    this.target = this.$refs.target;
                },
                copy() {
                    const el = this.$el;
                    const i = el.querySelector('i');
                    const previous = i.className;
                    try {
                        navigator.clipboard.writeText(this.target.value).then((r) => {
                            i.className = 'fa-solid fa-check';
                            setTimeout(() => {
                                i.className = previous;
                            }, 1000);
                        });
                    } catch (e) {
                        this.target.select();
                        document.execCommand('copy');
                    }
                }
            }));

            Alpine.data('tabs', () => ({
                el: null,
                list: null,
                tabs: null,
                init() {
                    this.el = this.$el;
                    this.list = this.$refs.list;
                    this.tabs = this.$refs.tabs;
                },
                change() {
                    const el = this.$el;
                    const li = el.closest('li');
                    this.list.querySelectorAll('.nav-link').forEach((el) => {
                        el.classList.remove('active');
                    });
                    el.classList.add('active');
                    const index = Array.prototype.indexOf.call(li.parentNode.children, li);
                    this.tabs.querySelectorAll('.tab-pane').forEach((el) => {
                        el.classList.remove('active');
                        el.classList.remove('show');
                    });
                    const active = this.tabs.children[index];
                    active.classList.add('active');
                    active.classList.add('show');
                }
            }));

            Alpine.data('chart', () => ({
                init() {
                    const el = this.$el;
                    const canvas = document.querySelector(el.dataset.canvas);
                    const config = JSON.parse(el.value);
                    const months = config.options.strings.months;
                    config.options.scales.x.ticks.callback = (value, index, values) => {
                        const date = new Date();
                        const days = 30 - value;
                        date.setDate(date.getDate() - days);
                        const month = months[date.getMonth()]?.substring(0, 3) || `${date.getMonth()}/`;
                        return `${month} ${date.getDate()}`;
                    };
                    el.dataset.chart = new Chart(canvas.getContext('2d'), config);
                }
            }));

            Alpine.data('slug', () => ({
                target: null,
                init() {
                    this.target = this.$refs.target;
                },
                slugify() {
                    const el = this.$el;
                    if (this.target.value === '') {
                        this.target.value = obj.slugify(el.value);
                    }
                }
            }));

            Alpine.data('tags', () => ({
                input: null,
                textarea: null,
                list: null,
                tags: null,
                serialize: null,
                init() {
                    this.input = this.$refs.input;
                    this.textarea = this.$refs.textarea;
                    this.list = this.$refs.list;
                    this.tags = this.$refs.tags;
                    this.serialize = this.$el.dataset.serialize ?? 'json';
                    this.load();
                },
                append() {
                    const el = this.$el;
                    const selected = this.list.querySelector(`[data-id="${el.value}"]`);
                    if (selected) {
                        const id = selected.dataset.id;
                        const other = this.tags.querySelector(`[data-id="${id}"]`);
                        if (!other) {
                            const color = selected.dataset.color;
                            const value = selected.textContent;
                            this.tags.insertAdjacentHTML('beforeend', this.option(id, value, color));
                        }
                        el.value = '';
                        this.save();
                    }
                },
                remove() {
                    const el = this.$el;
                    const tag = el.closest('.tag');
                    tag.remove();
                    this.save();
                },
                load() {
                    let selection;
                    switch(this.serialize) {
                        case 'pipe':
                            selection = this.textarea.value.split('|');
                            selection = selection.map((item) => parseInt(item));
                        break;
                        case 'json':
                            selection = JSON.parse(this.textarea.value);
                        break;
                    }
                    const tags = this.list.querySelectorAll('option');
                    tags.forEach((tag) => {
                        const id = parseInt(tag.dataset.id);
                        if (selection.includes(id)) {
                            const color = tag.dataset.color;
                            const value = tag.textContent;
                            this.tags.insertAdjacentHTML('beforeend', this.option(id, value, color));
                        }
                    });
                },
                save() {
                    const tags = this.tags.querySelectorAll('.tag');
                    const selection = [];
                    tags.forEach((tag) => {
                        selection.push( parseInt(tag.dataset.id) );
                    });
                    switch(this.serialize) {
                        case 'pipe':
                            this.textarea.value = selection.join('|');
                        break;
                        case 'json':
                            this.textarea.value = JSON.stringify(selection);
                        break;
                    }
                },
                option(id, value, color) {
                    value = _.escape(value);
                    return `<span class="tag" data-id="${id}" title="${value}"><span class="led" style="background-color: ${color}"></span><strong>${value}</strong><a href="#" @click.prevent="remove"><i class="fa-solid fa-xmark"></i></a></span>`;
                }
            }));

            Alpine.data('checkboxes', () => ({
                container: null,
                init() {
                    this.container = this.$refs.container;
                },
                toggle() {
                    const checked = this.$el.checked;
                    const checkboxes = this.container.querySelectorAll('input[type=checkbox]');
                    checkboxes.forEach((checkbox) => {
                        checkbox.checked = checked;
                    });
                }
            }));

            Alpine.data('editor', () => ({
                textarea: null,
                container: null,
                editor: null,
                init() {
                    this.textarea = this.$el;
                    this.textarea.classList.add('d-none');
                    this.container = document.createElement('div');
                    this.container.className = 'block-editor';
                    this.container.id = crypto.randomUUID().toString();
                    this.textarea.after(this.container);
                    this.editor  = new EditorJS({
                        holder: this.container.id,
                        data: this.textarea.value ? JSON.parse(this.textarea.value) : null,
                        minHeight: 32,
                        placeholder: 'Type to choose a block...',
                        tools: {
                            header: {
                                class: Header,
                                config: {
                                    levels: [2, 3, 4],
                                    defaultLevel: 2
                                }
                            },
                            list: {
                                class: EditorjsList,
                                inlineToolbar: true,
                                maxLevel: 2
                            },
                            image: {
                                class: ImageTool,
                                config: {
                                    endpoints: {
                                        byFile: `${window.Admin.url}/attachments/xhr/upload`,
                                        byUrl: `${window.Admin.url}/attachments/xhr/import`
                                    },
                                    additionalRequestHeaders: {
                                        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]')?.content
                                    },
                                    features: {
                                        border: false,
                                        stretch: false,
                                        background: false,
                                        caption: false
                                    }
                                }
                            },
                            delimiter: Delimiter,
                        },
                        onChange: (api, event) => {
                            this.editor.save().then((data) => {
                                this.textarea.value = JSON.stringify(data);
                            });
                        }
                    });
                }
            }));

            Alpine.data('toggle', () => ({
                target: null,
                type: null,
                init() {
                    this.type = this.$el.dataset.type ?? 'simple';
                    this.target = this.type === 'simple' ? this.$refs.target : this.$el.querySelectorAll('[data-target]');
                },
                after(el) {
                    const action = el.dataset.after ?? null;
                    const target = el.dataset.actionTarget ? document.querySelector(el.dataset.actionTarget) : el;
                    switch(action) {
                        case 'toggle':
                            target.classList.toggle('d-none');
                        break;
                        case 'show':
                            target.classList.remove('d-none');
                        break;
                        case 'hide':
                            target.classList.add('d-none');
                        break;
                        case 'remove':
                            target.remove();
                        break;
                    }
                },
                toggle() {
                    const el = this.$el;
                    switch(this.type) {
                        case 'simple':
                            this.processTarget(this.target, el);
                        break;
                        case 'multiple':
                            this.target.forEach((target) => {
                                this.processTarget(target, el);
                            })
                        break;
                    }
                },
                show() {
                    const el = this.$el;
                    this.target.classList.remove('d-none');
                    this.toggleDisabled(this.target,false);
                    this.after(el);
                },
                hide() {
                    const el = this.$el;
                    this.target.classList.add('d-none');
                    this.toggleDisabled(this.target,true);
                    this.after(el);
                },
                processTarget(target, el) {
                    const condition = target.dataset.condition ?? null;
                    const value = target.dataset.value ?? null;
                    if (condition === null) {
                        target.classList.toggle('d-none');
                        this.toggleDisabled();
                        this.after(el);
                    } else {
                        let result = false;
                        switch (condition) {
                            case 'equal':
                                result = value === (el.value ?? null);
                            break;
                            case 'notEqual':
                                result = value !== (el.value ?? null);
                            break;
                            case 'matches':
                            case 'notMatches':
                                const expr = new RegExp(value, 'i');
                                const matches = expr.test(el.value);
                                result = condition === 'matches' ? matches : !matches;
                            break;
                            default:
                                throw new Error(`Invalid condition type: ${condition}`);
                        }
                        target.classList.toggle('d-none', !result);
                        this.toggleDisabled(target, !result);
                        this.after(el);
                    }
                },
                toggleDisabled(target, state) {
                    target.querySelectorAll('input, textarea, select').forEach(el => {
                        el.disabled = state;
                    });
                }
            }));

            Alpine.data('color', () => ({
                el: null,
                input: null,
                target: null,
                init() {
                    this.el = this.$el;
                    this.target = this.$refs.target;
                    this.input = this.el.querySelector('input[type=text]');
                    this.input.addEventListener('change', e => this.update());
                    this.update();
                },
                update() {
                    this.target.style.backgroundColor = this.input.value;
                }
            }));

            Alpine.data('mask', () => ({
                el: null,
                mask: [],
                init() {
                    const mask = this.$el.getAttribute('data-mask');
                    this.el = this.$el;
                    let optional = false;
                    for (let i = 0; i < mask.length; i++) {
                        const current = mask.charAt(i);
                        switch (current) {
                            case '0':
                                this.mask.push({
                                    evaluator: (char) => (/[0-9]/).test(char),
                                    optional: optional
                                });
                                break;
                            case 'a':
                                this.mask.push({
                                    evaluator: (char) => (/[a-z]/i).test(char),
                                    optional: optional
                                });
                                break;
                            case 'x':
                                this.mask.push({
                                    evaluator: (char) => (/[a-f0-9]/i).test(char),
                                    optional: optional
                                });
                                break;
                            case '*':
                                this.mask.push({
                                    evaluator: (char) => true,
                                    optional: optional
                                });
                                break;
                            case '[':
                                optional = true;
                                break;
                            case ']':
                                optional = false;
                                break;
                            default:
                                this.mask.push({
                                    evaluator: (char) => char === current,
                                    optional: optional
                                })
                                break;
                        }
                    }
                },
                applyMask() {
                    const value = this.el.value;
                    let remove = false;
                    if (value.length > this.mask.length) {
                        remove = true;
                    } else {
                        const position = value.length - 1;
                        const current = this.mask[position];
                        remove = !current.evaluator(value.charAt(position));
                    }
                    if (remove) {
                        this.el.value = value.slice(0, -1);
                    }
                },
            }));

            Alpine.data('sourcecode', () => ({
                textarea: null,
                wrapper: null,
                source: null,
                editor: null,
                init() {
                    const mode = this.$el.dataset.mode;

                    this.source = document.createElement('div');
                    this.source.className = 'sourcecode-editor';

                    this.wrapper = document.createElement('div');
                    this.wrapper.className = 'sourcecode';
                    this.wrapper.append(this.source);

                    this.textarea = this.$el;
                    this.textarea.before(this.wrapper);
                    this.textarea.classList.add('d-none');

                    this.editor = ace.edit(this.source);

                    this.editor.setOption('highlightActiveLine', false);
                    this.editor.session.setOption('mode', `ace/mode/${mode}`);
                    this.editor.renderer.setOption('fontSize', 16);
                    this.editor.renderer.setOption('theme', 'ace/theme/github');
                    this.editor.renderer.setOption('printMargin', false);

                    this.editor.getSession().setValue(this.textarea.value);

                    this.editor.getSession().on('change', () => {
                        this.textarea.value = this.editor.getSession().getValue();
                    });
                }
            }));
        });

        this.#conditionals = new Conditionals();
    }

    onDomReady() {
        Coloris({
            theme: 'polaroid',
            alpha: false,
            swatches: [
                '#e53935', '#fb8c00', '#fdd835', '#ffeb3b', '#c0ca33', '#8bc34a',
                '#43a047', '#00897b', '#00acc1', '#039be5', '#1e88e5', '#5e35b1',
                '#8e24aa', '#6a1b9a', '#d81b60', '#ec407a', '#795548', '#78909C',
            ]
        });

        const form = document.getElementById('form');
        if (form !== null) {
            this.#conditionals.init(form);
        }
    }

    slugify(str) {
        str = str.replace(/^\s+|\s+$/g, ''); // trim
        str = str.toLowerCase();
        let from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;";
        let to   = "aaaaeeeeiiiioooouuuunc------";
        for (let i=0, l=from.length ; i<l ; i++) {
            str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
        }
        str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
            .replace(/\s+/g, '-') // collapse whitespace and replace by -
            .replace(/-+/g, '-'); // collapse dashes
        return str;
    };
}

window.app = window.app || new App();
